import React, { useEffect, useState } from 'react';
import styles from './InputStake.module.scss';
import classNames from 'classnames';
import { indexOf } from 'lodash';

/* Components */
import { InputHeader } from '../shared/InputHeader/InputHeader';
import { InputStakeSelection } from './InputStakeSelection';

/* Translations */
import { tr } from '../../../utils/translations/translator';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { TipsterPreferencesState } from '../../../store/tipsterPreferences/reducer';
import { RootState } from '../../../store';

type Stake =
  | 0.5
  | 1
  | 1.5
  | 2
  | 2.5
  | 3
  | 3.5
  | 4
  | 4.5
  | 5
  | 5.5
  | 6
  | 6.5
  | 7
  | 7.5
  | 8
  | 8.5
  | 9
  | 9.5
  | 10
  | 15
  | 20
  | 25
  | 30
  | 35
  | 40
  | 45
  | 50
  | 55
  | 60
  | 65
  | 70
  | 75
  | 80
  | 85
  | 90
  | 95
  | 100;

const STAKES = [
  0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5,
  10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100,
];

interface InputStakeProps {
  featured?: Stake[];
  handleChange: (stake: number) => void;
  closeModal: () => void;
  value: number;
  setIsCloseModalBlocked: (b: boolean) => void;
  isSpecialChannelSelected: boolean;
}
interface DispatchProps {
  tipsterPreferences: TipsterPreferencesState;
}
export const InputStake: React.FC<InputStakeProps & DispatchProps> = ({
  featured = [3, 5, 7],
  handleChange,
  closeModal,
  value,
  tipsterPreferences,
  setIsCloseModalBlocked,
  isSpecialChannelSelected,
}) => {
  const [stake, setStake] = useState<number>(value);
  const [untilAvailable, setUntilAvailable] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
  });
  const [isSuperStakeAvailable, setIsSuperStakeAvailable] = useState(true);
  const handleStake = (stake: number) => {
    setStake(stake);
    handleChange(stake);
  };

  const { t } = useTranslation();
  const cx = classNames.bind(styles);

  const handlePreviousStake = () => {
    const index = indexOf(filteredStakes, stake);
    if (index !== 0) {
      handleStake(filteredStakes[index - 1]);
    }
  };

  const handleNextStake = () => {
    const index = indexOf(filteredStakes, stake);
    if (index !== filteredStakes.length - 1) {
      handleStake(filteredStakes[index + 1]);
    }
  };

  const getPrevious = () => {
    const index = indexOf(filteredStakes, stake);
    if (index !== 0) {
      return filteredStakes[index - 1];
    }
    return undefined;
  };

  const getNext = () => {
    const index = indexOf(filteredStakes, stake);
    if (index !== filteredStakes.length - 1) {
      return filteredStakes[index + 1];
    }
    return undefined;
  };
  
const filteredStakes = isSpecialChannelSelected
  ? STAKES // Si es challenge, mostramos todos los stakes
  : STAKES.filter((s) => s <= 20); // Si no es challenge, solo hasta 20

  useEffect(() => {
    // Eliminar la lógica que actualiza isSuperStakeAvailable
    // const isSuperStakeAvailable =
    //   tipsterPreferences.data.is_super_confidence_available;
    const untilAvailable =
      tipsterPreferences.data.until_super_confidence_available;

    setUntilAvailable(untilAvailable);
    // setIsSuperStakeAvailable(isSuperStakeAvailable);
  }, [tipsterPreferences.data]);

  useEffect(() => {
    // Eliminar la lógica que bloquea el modal basado en isSuperStakeAvailable
    // if (value === 20 && !isSuperStakeAvailable) {
    //   setIsCloseModalBlocked(true);
    // } else {
    //   setIsCloseModalBlocked(false);
    // }
    setIsCloseModalBlocked(false);
  }, [value]);

  return (
    <div className={styles.InputStake}>
      <div className={styles.topRow}>
        <span className={styles.text}>{tr(t, 'select-stake')}</span>
        <button onClick={() => closeModal()} className={styles.okay}>
          Ok
        </button>
      </div>

      {featured && (
        <>
          <InputHeader title={tr(t, 'most-used-by-you')} />
          <div className={cx(styles.InputStakeSelection, styles.featured)}>
            {featured
              .filter((f) => filteredStakes.includes(f))
              .map((featuredElement: Stake, index: number) => (
                <div
                  key={index}
                  onClick={() => {
                    handleStake(featuredElement);
                    if (!isSuperStakeAvailable && featuredElement === 20) {
                      return;
                    } else closeModal();
                  }}
                  className={
                    stake === featuredElement
                      ? cx(styles.valueBox, styles.selected)
                      : styles.valueBox
                  }
                >
                  {featuredElement}
                </div>
              ))}
          </div>
        </>
      )}

      <InputHeader title={tr(t, 'most-used-by-others')} />
      <InputStakeSelection
        value={stake}
        previous={getPrevious()}
        next={getNext()}
        handleNext={handleNextStake}
        handlePrevious={handlePreviousStake}
        isSuperStakeAvailable={isSuperStakeAvailable}
        untilAvailable={untilAvailable}
      />
    </div>
  );
};
const mapStateToProps = (state: RootState) => ({
  tipsterPreferences: state.tipsterPreferences,
});

export const ConnectedInputStake = connect(mapStateToProps)(InputStake);
